export default {
  networks: [],
  domains: [],
  backend_sets: [],
  tunnels: [],
  tunnel_locations: [],
  certificates: [],
  certificate_suggestions: [],
  selected_backend_set: null,
};
